import { ReactComponent as SignalFastDarkSVG } from "./icons/node-signal-fast-dark.svg";
import { ReactComponent as SignalFastSVG } from "./icons/node-signal-fast.svg";
import { ReactComponent as SignalMediumDarkSVG } from "./icons/node-signal-medium-dark.svg";
import { ReactComponent as SignalMediumSVG } from "./icons/node-signal-medium.svg";
import { ReactComponent as SignalSlowDarkSVG } from "./icons/node-signal-slow-dark.svg";
import { ReactComponent as SignalSlowSVG } from "./icons/node-signal-slow.svg";
import { ReactComponent as SignalUnavailableDarkSVG } from "./icons/node-signal-unavailable-dark.svg";
import { ReactComponent as SignalUnavailableSVG } from "./icons/node-signal-unavailable.svg";

export const DarkSignalIcons = {
  Fast: SignalFastDarkSVG,
  Medium: SignalMediumDarkSVG,
  Slow: SignalSlowDarkSVG,
  Unavailable: SignalUnavailableDarkSVG,
};

export const LightSignalIcons = {
  Fast: SignalFastSVG,
  Medium: SignalMediumSVG,
  Slow: SignalSlowSVG,
  Unavailable: SignalUnavailableSVG,
};
